'use client';

import { c as _c } from "react/compiler-runtime";
import { jsxs, jsx } from 'react/jsx-runtime';
import { useLocalStorageValue } from '@react-hookz/web';
import { useGetIntl } from '@repo/i18n/intl/client';
import { cn } from '@repo/lib';
function ColorSchemeSelector(t0) {
  const $ = _c(13);
  const {
    className,
    dictionaryPromise,
    idPrefix: t1,
    lang,
    showTitle: t2
  } = t0;
  const idPrefix = t1 === undefined ? "" : t1;
  const showTitle = t2 === undefined ? true : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      defaultValue: "\uD83D\uDCBB"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    value: colorScheme,
    set: setColorScheme
  } = useLocalStorageValue("colorScheme", t3);
  let t4;
  if ($[1] !== dictionaryPromise || $[2] !== lang) {
    t4 = {
      dictionaryPromise,
      lang
    };
    $[1] = dictionaryPromise;
    $[2] = lang;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const intl = useGetIntl(t4);
  const t5 = !showTitle;
  let t6;
  if ($[4] !== className || $[5] !== colorScheme || $[6] !== idPrefix || $[7] !== intl || $[8] !== setColorScheme || $[9] !== t5) {
    let t7;
    if ($[11] !== setColorScheme) {
      t7 = event => setColorScheme(event.target.value);
      $[11] = setColorScheme;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t6 = jsxs("section", {
      children: [jsx("label", {
        className: cn("block mb-4 text-lg uppercase", {
          hidden: t5
        }),
        htmlFor: `${idPrefix}-color-scheme-select`,
        children: intl.formatMessage({
          defaultMessage: "Color Scheme",
          description: "Title for color scheme selector",
          id: "H3MpNr"
        })
      }), jsxs("select", {
        className: cn("bg-transparent border-none outline-none ring-0 focus:ring-0 focus:outline-none py-0 ps-0", className),
        id: `${idPrefix}-color-scheme-select`,
        name: "colorScheme",
        onChange: t7,
        value: colorScheme,
        children: [jsx("option", {
          value: "\uD83D\uDCBB",
          children: "System default"
        }), jsx("option", {
          value: "\u2600\uFE0F",
          children: "Light mode"
        }), jsx("option", {
          value: "\uD83C\uDF11",
          children: "Dark mode"
        })]
      })]
    });
    $[4] = className;
    $[5] = colorScheme;
    $[6] = idPrefix;
    $[7] = intl;
    $[8] = setColorScheme;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
export { ColorSchemeSelector };